module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/qdige3-402d99267f098a016991548ba14efc74.jpg";